/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


let config = {  
    
    
    title : {
        key :'Biz4',
        value : 'Biz4'
    },
            
}

export default config;

